<div [dir]="this.lang.getPageDirection()" class="dialog-wrapper"
cdkDrag
cdkDragRootElement=".cdk-overlay-pane">

<div class="dialog-header" cdkDragHandle>
   <span class="dialog-title" [matTooltip]="'messages.messages-app-dialo.draggable' | translate"></span>
   <div class="dialog-actions">
       <button mat-icon-button class="minimize-button" (click)="minimizeDialog()" aria-label="Minimize dialog" [matTooltip]="'messages.messages-app-dialo.minimize' | translate">
           <mat-icon>minimize</mat-icon>
       </button>
       <button mat-icon-button class="close-button" (click)="closeDialog()" aria-label="Close dialog" [matTooltip]="'messages.pat-comp-msg-close' | translate">
           <mat-icon>close</mat-icon>
       </button>
   </div>
</div>

<div class="iframe-container">
   <iframe 
   [src]="safeUrl" 
   sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
   allow="local-network-access; clipboard-read; clipboard-write">
   </iframe>
   
</div>

</div>